import { buildTheme } from '~theme/utils'

/**
 * name of an attribute that should be added to each element
 * where bg color is set and should be set to the full bgColorKey
 */
export const THEME_KEY_ATTRIBUTE = `data-bg-color-key` // has to be lower case because of React

/**
 * an HTML element ID that should be passed to the top-level
 * element of the theme design tools,
 * it’s later used to recognize whether the mouse click was done
 * on the design tools or the app itself
 */
export const DESIGN_TOOLS_ELEMENT_ID = `themeDesignTools`

type TThemeConfigBaseColors = FirstParam<typeof buildTheme>['baseColors']
type TBaseColor = keyof TThemeConfigBaseColors

/**
 * theme config base colors,
 * used as ColorList items that may set multiple theme keys at once
 */
export const BASE_THEME_CONFIG_COLORS: Record<TBaseColor, TBaseColor> = {
  companyPrimary: `companyPrimary`,
  conversion: `conversion`,
}
